import './index.css';

import App from './app';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import store from './store';
import { getQueryParams } from './utils/helpers';
import { ErrorBoundary } from './ErrorBoundary';
import { isMesaOpenInAnotherTab } from './utils/tabLock';

const inactive = isMesaOpenInAnotherTab();

if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value(callback, type, quality) {
      const binStr = atob(this.toDataURL(type, quality).split(',')[1]);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      callback(new Blob([arr], { type: type || 'image/png' }));
    }
  });
}

const params = getQueryParams();

if (params.productId === params.itemId) {
  params['productId'] = '6';
}

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <App
        itemID={params.itemId}
        productID={params.productId}
        print={params.print}
        page={params.page}
        haveCover={params.cover}
        thumb={params.thumb}
        inactive={inactive}
        productType="photobook"
        pages={params.pages}
        back={params.back}
      />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();
